// eslint-disable
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import FormArrowButton from '../buttons/FormArrow';
import FullButton from '../buttons/Full';

import { sendNewsletter } from '../../lib/requests';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/email-form.scss';

const propTypes = {
    intl: AppPropTypes.intl.isRequired,
    path: PropTypes.string,
    successMessage: AppPropTypes.message,
    errorMessage: AppPropTypes.message,
    fillMessage: AppPropTypes.message,
    sponsorsMessage: AppPropTypes.message,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    path: null,
    successMessage: { id: 'content.pop_ups.wabush.success' },
    errorMessage: { id: 'content.pop_ups.wabush.error' },
    fillMessage: { id: 'content.pop_ups.wabush.fill' },
    sponsorsMessage: { id: 'content.pop_ups.wabush.sponsors' },
    onClose: null,
    onSuccess: null,
    className: null,
};

const EmailForm = ({
    intl,
    path,
    successMessage,
    errorMessage,
    fillMessage,
    sponsorsMessage,
    onClose,
    onSuccess,
    className,
}) => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState(null);
    const [secondMessage, setSecondMessage] = useState(null);
    const [inputData, setInputData] = useState({ email: '' });

    const onClickClose = useCallback(() => {
        if (onClose !== null) {
            onClose(success);
        }
    }, [onClose, success]);

    const onEmailChange = useCallback(
        (e) => {
            setInputData({ ...inputData, email: e.target.value });
        },
        [inputData, setInputData],
    );

    const onSubmit = useCallback(
        (e) => {
            e.preventDefault();
            if (inputData.email) {
                sendNewsletter(`/api/${path}`, inputData)
                    .then((succ) => {
                        if (succ) {
                            setMessage(intl.formatMessage(successMessage));
                            setSecondMessage(intl.formatMessage(sponsorsMessage));
                            setInputData({ name: '', email: '', city: '' });
                            setSuccess(true);
                            setError(false);
                            if (onSuccess !== null) {
                                onSuccess();
                            }
                        } else {
                            setMessage(intl.formatMessage(errorMessage));
                            setError(true);
                        }
                    })
                    .catch(() => {
                        setMessage(intl.formatMessage(errorMessage));
                        // setError(true);
                    });
            } else {
                setMessage(intl.formatMessage(fillMessage));
            }
        },
        [
            inputData,
            setInputData,
            setMessage,
            setSecondMessage,
            success,
            setSuccess,
            setError,
            onSuccess,
            path,
            successMessage,
            errorMessage,
            fillMessage,
            sponsorsMessage,
        ],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {!success ? (
                <form className={styles.form}>
                    <input
                        className={styles.input}
                        type="email"
                        placeholder={intl.formatMessage({ id: 'content.email.email' })}
                        onChange={onEmailChange}
                        value={inputData.email}
                    />
                    <FormArrowButton className={styles.send} onClick={onSubmit} type="submit" />
                </form>
            ) : null}
            {message ? <p className={styles.message}>{message}</p> : null}
            {secondMessage ? <p className={styles.message}>{secondMessage}</p> : null}
            {success || error ? (
                <FullButton highlighted onClick={onClickClose}>
                    {intl.formatMessage({ id: 'content.pop_ups.wabush.watch' })}
                </FullButton>
            ) : null}
        </div>
    );
};

EmailForm.propTypes = propTypes;
EmailForm.defaultProps = defaultProps;

export default injectIntl(EmailForm);
